import React from 'react'
import { MetricsGrid, SectionTitle } from '../styles'
import MetricCard from './MetricCard'

const MetricsSection = ({ title, metrics = [] }) => {
    if (!metrics?.length) return null

    return (
        <div>
            {title && <SectionTitle>{title}</SectionTitle>}
            <MetricsGrid>
                {metrics.map((metric) => (
                    <MetricCard key={metric.key || metric.label} metric={metric} />
                ))}
            </MetricsGrid>
        </div>
    )
}

export default MetricsSection
